import { actionCreator } from '../../../utils/actions';

export const resetCurrentJourney = actionCreator('RidesSidebar/RESET_CURRENT_JOURNEY');
export const changeCurrentJourney = actionCreator('RidesSidebar/CHANGE_CURRENT_JOURNEY');
export const previewJourney = actionCreator('RidesSidebar/PREVIEW_JOURNEY');
export const resetPreviewedJourney = actionCreator('RidesSidebar/RESET_PREVIEWED_JOURNEY');



// WEBPACK FOOTER //
// ./src/components/Sidebar/RidesSidebar/actions.js